import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route, useLocation } from 'react-router-dom';

import Login from 'components/Login';
import Logout from 'components/Logout';
import Main from 'components/Main';

import { closeModal } from '../../actions/index';

function App() {
    const dispatch = useDispatch();
    const location = useLocation();

    useEffect(() => {
        dispatch(closeModal());
    }, [location.pathname]);

    return (
        <Switch>
            <Route path="/login" component={Login} />
            <Route path="/logout" component={Logout} />
            <Route path="/" component={Main} />
        </Switch>
    );
}

export default App;
